import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import MsgTmplAdminDetailsView from "./MsgTmplAdminDetailsView";
import MsgTmplAdminNewView     from "./MsgTmplAdminNewView";


const MsgTmplAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Language"),
      selector: row => t("I18N_Lng_" + row.language),
      wrap: true,
      sortable: true,
      sortField: 'language',
    },
    {
      name: t("I18N_Type"),
      selector: row => t("I18N_" + row.type),
      grow: 0.5,
      wrap: true,
      sortable: true,
      sortField: 'type',
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_PLATFORM_API}
                                                  apiObjName={'msg-templates'}
                                                  listPageTitle={t("I18N_MsgTmpl_Management")}
                                                  newObjTooltip={t("I18N_MsgTmpl_Management")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_MsgTmpl_del_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_msg_tmpl")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'NAME'}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <MsgTmplAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <MsgTmplAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default MsgTmplAdmin;
